import React from "react";
import ListView from "../components/ListView";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../../utils/recoil";

const Paths = () => {
  const [data] = useRecoilState(detailedResultState);
  return (
    <div className="px-[20rem] md-max:px-[1rem] flex flex-col gap-10 -mt-10">
      <p className="text-xl md-max:text-[16px]">{data?.career_path?.description}</p>

      <ListView example={false} data={data?.career_path?.paths} />
    </div>
  );
};

export default Paths;
